"use client"
import Image from 'next/image'

export default function Socials({ items = [] }) {
  if (!items.length) return null

  return (
    <ul role="list" className="mt-4 flex items-center gap-3">
      {items.map((item) => (
        <li key={item.id} className="group">
          <a href={item.link || '#'} target="_blank" rel="noopener noreferrer" className="inline-flex items-center">
            {item.icon ? (
              <Image src={item.icon} alt={item.name || ''} width={24} height={24} className="opacity-80 group-hover:opacity-100 transition" />
            ) : (
              <span className="text-sm/6 px-2 py-1 bg-gray-200 rounded">{item.name}</span>
            )}
          </a>
        </li>
      ))}
    </ul>
  )
}


